export default "/* purgecss start ignore */\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\n\n/* purgecss end ignore */\n"